import React, { Component } from 'react';

import { LayoutAlign, LayoutJustify, PanelAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { any, arrayOf, bool, node, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, enumValues, getLostProps, propagateData } from '@philips-emr/tws-utils';

import './panel.scss';

const acceptedTypes = enumValues(ComponentType);

@AwesomeComponent({ type: ComponentType.LAYOUT, api: PanelAPI })
class Panel extends Component {
  static propTypes = {
    alignItems: oneOf(enumValues(LayoutAlign)).group('alignment'),
    background : string,
    border: string.group('borders'),
    borderRadius: oneOf(['0px', '8px', '16px', '24px', '32px']).group('borders'),
    boxShadow: string,
    children: oneOfType([node, arrayOf(node)]).notEnumerable(),
    className: string,
    data: any.notEnumerable(),
    gridArea: string.notEnumerable(),
    justifyContent: oneOf(enumValues(LayoutJustify)).group('alignment'),
    lightTheme: bool.group('theme'),
    margin: string.group('spacing'),
    padding: string.group('spacing'),
    uuid: string.notEnumerable(),
    visible: bool,
  };

  static defaultProps = {
    gridArea : '',
    visible: true,
  };

  renderChildren() {
    const { data, children, ...otherProps } = this.props;
    const lostProps = getLostProps(Panel.propTypes, otherProps);

    return propagateData(children, data, lostProps);
  }

  getStyle() {
    const {
      alignItems,
      background,
      border,
      borderRadius,
      boxShadow,
      gridArea,
      justifyContent,
      margin,
      padding,
    } = this.props;

    return {
      alignItems,
      background,
      border,
      borderRadius,
      boxShadow,
      gridArea,
      justifyContent,
      margin,
      padding,
    };
  }

  getClassName() {
    const { lightTheme, className } = this.props;

    return classNames({
      'c-panel': true,
      't-light': lightTheme,
      [className]: Boolean(className),
    });
  }

  render() {
    const { uuid, visible } = this.props;

    if (!visible) return null;

    const Container = ContainerProvider.provide(this);

    return (
      <Container acceptedTypes={acceptedTypes} className={this.getClassName()} uuid={uuid} style={this.getStyle()}>
        {this.renderChildren()}
      </Container>
    );
  }
}

export default Panel;
